import { Button, Wrapper, LazyImage } from '@frontend/design_system'
import Logo from 'assets/img/smallLogo.svg'
import { EnvironmentVariablesService } from 'utils/env'
import styles from './index.module.scss'
import { useNavigate } from 'react-router-dom'
import { URLS } from 'constants/urls'
import { MARKETPLACE_LABEL } from 'texts/header'
import { authIsLoadedSelector, userDataSelector } from 'redux/login/selectors'
import { useSelector } from 'react-redux'

export const Header = () => {
  const navigate = useNavigate()
  const handleRedirectToMarketplace = () => {
    navigate(URLS.SIGNIN)
  }
  const isLoaded = useSelector(authIsLoadedSelector)
  const userData = useSelector(userDataSelector)

  const isLoggedIn = isLoaded && userData.displayName

  const handleRedirectToEconomyBookings = () => {
    window.location.href = EnvironmentVariablesService.getEnv(
      'REACT_APP_MAIN_APP_URL'
    ) as string
  }

  return (
    <div className={styles.header} data-testid="header">
      <Wrapper>
        <div className={styles['header-content']}>
          <LazyImage
            src={Logo}
            width={83}
            height={34}
            onClick={handleRedirectToEconomyBookings}
          />
          <div className={styles['button-wrapper']}>
            <Button
              typographyName="body1WBold"
              label={isLoggedIn ? MARKETPLACE_LABEL : 'Sign in'}
              variant="secondary"
              size="large"
              onClick={handleRedirectToMarketplace}
              dataTestId="sign-in-redirect-button"
            />
          </div>
        </div>
      </Wrapper>
    </div>
  )
}
